import { put, takeLatest, fork, call } from "redux-saga/effects";

import {
  ActionType,
  DepartmentListBusinessResponse,
} from "models/userListBusiness/departmentList";
import { httpStatus } from "configs/httpStatus";
import { fetchDepartmentList } from "services/userListBusiness";

import {
  handleSuccesAction,
  handleErrorAction,
} from "./departmentsListActions";

function* getDepartmentListSaga() {
  try {
    const response: DepartmentListBusinessResponse = yield call(
      fetchDepartmentList
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetDepartmentListWatcher() {
  yield takeLatest(
    ActionType.DEPARTMENT_LIST_BUSINESS as any,
    getDepartmentListSaga
  );
}

export default [fork(onGetDepartmentListWatcher)];
